import Vue from "vue";
import Lang from "lang.js";
import store from "./store.js";
import VueCarousel from "vue-carousel";
import ScrollReveal from "scrollreveal";
import axios from "axios";

window.axios = axios;

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["X-CSRF-TOKEN"] = document.querySelector(
    'meta[name="csrf-token"]'
).content;

//translations currently available on app-map.blade only
const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;
const messages = window.messages;
Vue.config.productionTip = false;

import MainNews from "./components/MainNews";
import Accessibility from "./components/Accessibility";
import Leaflet from "./map/Leaflet";
import MapMenu from "./map/MapMenu";
import MapModal from "./map/MapModal";
import CookiePopUp from "./components/CookiePopUp";
import PaymentSearch from "./components/PaymentSearch";

Vue.use(VueCarousel);
Vue.prototype.trans = new Lang({
    messages,
    locale: default_locale,
    fallback: fallback_locale,
});
Vue.filter("trans", (key) => {
    return Vue.prototype.trans.get(key);
});
Vue.mixin({
    methods: {
        route: route,
    },
});
const App = new Vue({
    el: "#app",

    components: {
        MainNews,
        Accessibility,
        Leaflet,
        MapMenu,
        MapModal,
        CookiePopUp,
        PaymentSearch,
    },
    store: store,
});

window.App = App;

ScrollReveal().reveal(".scroll-reveal", {
    delay: 300,
    duration: 500,
    easing: "ease-in",
});

ScrollReveal().reveal(".scroll-reveal-delay", {
    delay: 500,
    duration: 500,
    easing: "ease-in",
});
